/**
 * @generated SignedSource<<a49633e02cdfe9fe367414fae19fcfec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_project$data = {
  readonly key: string;
  readonly projectId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider197BadPattern">;
  readonly " $fragmentType": "main_issueNavigator_ListView_project";
};
export type main_issueNavigator_ListView_project$key = {
  readonly " $data"?: main_issueNavigator_ListView_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "NativeIssueTableWithSelectedIssuesProvider197BadPattern"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "2204e77d7b042a1fa9d46de7f61de808";

export default node;
